// extracted by mini-css-extract-plugin
export default {"successColor":"_z0ZUw"};